;
if (typeof jQuery === 'undefined') {
    throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

if (typeof app === 'undefined') {
    throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

(function (document, $, app) {
    $(document).ready(function () {
        app.init();
        
        if ($('.sticker').length > 0) {
            $('.sticker').sticky({
                topSpacing: 0
            });
        }
    });
})(document, jQuery, app);